import axios from "axios";

const API_BASE = `${process.env.REACT_APP_API_URL}/api/donations`; // backend base URL

// Update individual data (profile correction)
export async function updateProfileApi(data) {
    
  try {
    const res = await axios.post(`${API_BASE}/correct`, data, {
      headers: { "Content-Type": "application/json" },
    });
    return res.data; // returns provider response
  } catch (err) {
    console.error("updateProfileApi error:", err.response?.data || err.message);
    throw err;
  }
}
